export const BREAKPOINTS = {
  mobile: '768px',
  desktop: '1280px',
};

export const PRODUCTION_THEME = {
  colors: {
    brand: '#3B82F6',
    brandDark: '#1D4ED8',
    success: '#10B981',
    danger: '#EF4444',
    warning: '#F59E0B',
    surface: '#FFFFFF',
    surfaceMuted: '#F8FAFC',
    border: '#E2E8F0',
    textPrimary: '#0F172A',
    textMuted: '#64748B',
  },
};

